export default "__VITE_ASSET__6dc93ae9__"